import styled, {
  FlattenInterpolation,
  Palette,
  PaletteVariants,
  ThemedStyledProps,
} from 'styled-components';
import { TinkTheme } from '../../providers/ThemeProvider/theme';
import { MarginProps, styledMargin } from '../Margins/margins';
import { H1Style, H2Style, H3Style, H4Style, H5Style, heroStyle, subStyle } from './Heading.styles';

export type Variants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'hero' | 'sub';

export type HeadingProps = {
  as?: Variants;
  variant?: Variants;
  fontWeight?: 'regular' | 'semiBold';
  color?: Palette;
  shade?: PaletteVariants;
} & MarginProps;

export type VariantStyles = {
  [key in Variants]: FlattenInterpolation<ThemedStyledProps<HeadingProps, TinkTheme>>;
};

export const VariantStyles: VariantStyles = {
  h1: H1Style,
  h2: H2Style,
  h3: H3Style,
  h4: H4Style,
  h5: H5Style,
  hero: heroStyle,
  sub: subStyle,
};

const isVariant = (variant: Variants | string | undefined): variant is Variants => {
  return variant ? variant in VariantStyles : false;
};

export const Heading = styled.span<HeadingProps>`
  margin-top: 0;
  margin-bottom: ${(props) => props.theme.sizes.xxsmall};
  ${styledMargin};
  line-height: 1.25em;
  font-weight: ${(props) =>
    props.fontWeight
      ? props.theme.font.weights[props.fontWeight]
      : props.theme.font.weights.semiBold};
  ${(props) => {
    if (props.variant) {
      return VariantStyles[props.variant];
    }

    if (isVariant(props.as)) {
      return VariantStyles[props.as];
    }

    return null;
  }};
  ${(props) =>
    props.color &&
    `
    color: ${props.theme.palette[props.color][props.shade || 'main']};
  `}
`;
